/**
 * Private modules
 */
const {
  createQueryComponent,
  customerId,
  customerPropertyType,
  objectId,
  systemGameId,
} = require('../.private').components;

module.exports = {
  getCustomerPropertyBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent(),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  updateCustomerPropertyById: {
    properties: {
      body: {
        properties: {
          type: customerPropertyType,
          isSelfBlocked: {
            type: 'boolean',
            default: false,
          }
        },
        required: ['type'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          objectId,
        },
        required: [
          'customerId',
          'objectId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
